import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1] as const;

/** Standard scroll-reveal props for the demo page's motion language. */
export const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 28, filter: "blur(6px)" },
  whileInView: { opacity: 1, y: 0, filter: "blur(0px)" },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6, delay, ease: [...EASE] },
});

interface SectionHeadingProps {
  no: string;
  eyebrow: string;
  title: string;
  sub?: string;
  align?: "center" | "left";
}

/** Numbered chapter heading: `01 — EYEBROW`, title, optional subtitle. */
export const SectionHeading = ({ no, eyebrow, title, sub, align = "center" }: SectionHeadingProps) => {
  const centered = align === "center";
  return (
    <motion.div {...reveal()} className={centered ? "text-center" : "text-left"}>
      <div className={`flex items-center gap-3 ${centered ? "justify-center" : "justify-start"}`}>
        <span className="font-mono text-sm font-semibold text-secondary">{no}</span>
        <span aria-hidden className="h-px w-8 bg-slate-300" />
        <span className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">{eyebrow}</span>
      </div>
      <h2 className="mt-4 text-3xl font-bold tracking-tight text-slate-900 md:text-5xl">{title}</h2>
      {sub && (
        <p className={`mt-4 max-w-2xl text-lg leading-relaxed text-slate-600 ${centered ? "mx-auto" : ""}`}>
          {sub}
        </p>
      )}
    </motion.div>
  );
};
